import React, { createContext, Dispatch, useContext, useState } from 'react'
import noop from 'lodash/noop'

interface State {
  isOpen: boolean
  setIsOpen: Dispatch<React.SetStateAction<boolean>>
}

const initialValue: State = {
  isOpen: false,
  setIsOpen: noop,
}

const Context = createContext(initialValue)

export const TooltipProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(initialValue.isOpen)

  return <Context.Provider value={{ isOpen, setIsOpen }}>{children}</Context.Provider>
}

export const useTooltipContext = () => {
  const context = useContext(Context)

  if (!context) {
    throw Error('No Tooltip context found.')
  }

  return context
}
